"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.unknownVerifyFailure = exports.invalidCode = exports.sendFailure = void 0;
var React = __importStar(require("react"));
var ErrorBanner_1 = require("../../Common/ErrorBanner");
var LayoutContext_1 = require("../../Common/LayoutContext");
var enums_1 = require("../../Common/utils/enums");
var index_1 = require("../../index");
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var TwoFactorAuthenticationUtils_1 = require("../TwoFactorAuthenticationUtils");
var VerifyAccountContext_1 = __importDefault(require("../VerifyAccountContext"));
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["Blocked"] = "blocked";
    ErrorMessages["UnknownError"] = "unknown error";
    ErrorMessages["WrongCode"] = "wrong code";
})(ErrorMessages || (ErrorMessages = {}));
exports.sendFailure = (React.createElement(ErrorBanner_1.ErrorBanner, { bannerBody: TwoFactorAuthenticationStrings_1["default"].unexpectedErrorTryAgain(), bannerLabel: TwoFactorAuthenticationStrings_1["default"].couldntSendCode() }));
exports.invalidCode = function (attempts) { return (React.createElement(ErrorBanner_1.ErrorBanner, { bannerBody: TwoFactorAuthenticationStrings_1["default"].attemptsLeft(attempts), bannerLabel: TwoFactorAuthenticationStrings_1["default"].invalidOrIncorrectCode() })); };
exports.unknownVerifyFailure = (React.createElement(ErrorBanner_1.ErrorBanner, { bannerBody: TwoFactorAuthenticationStrings_1["default"].tryAgain(), bannerLabel: TwoFactorAuthenticationStrings_1["default"].somethingWentWrong() }));
var MfaError = function (_a) {
    var clearError = _a.clearError, sendError = _a.sendError, verifyError = _a.verifyError;
    var _b = React.useContext(index_1.RiskContext), client = _b.client, state = _b.state, shouldUseRiskBff = _b.shouldUseRiskBff;
    var setPrimaryAction = React.useContext(LayoutContext_1.LayoutContext).setPrimaryAction;
    var setMfaState = React.useContext(VerifyAccountContext_1["default"]).setMfaState;
    var _c = __read(React.useState(null), 2), error = _c[0], setError = _c[1];
    var isRestClient = !(client || shouldUseRiskBff);
    React.useEffect(function () {
        if (clearError) {
            setError(null);
        }
    }, [clearError]);
    React.useEffect(function () {
        if (sendError) {
            if (TwoFactorAuthenticationUtils_1.isUserBlocked(isRestClient, sendError)) {
                setMfaState(enums_1.MfaStates.Blocked);
            }
            else {
                setError(exports.sendFailure);
            }
        }
    }, [sendError]);
    React.useEffect(function () {
        if (verifyError) {
            var attempts = TwoFactorAuthenticationUtils_1.triesRemaining(isRestClient, verifyError);
            setPrimaryAction({ isSubmitting: false });
            if (TwoFactorAuthenticationUtils_1.isUserBlocked(isRestClient, verifyError)) {
                VerifyAccountTracking_1.trackOnFailure(state.workflow, ErrorMessages.Blocked);
                setMfaState(enums_1.MfaStates.Blocked);
            }
            else if (attempts > 0) {
                VerifyAccountTracking_1.trackOnFailure(state.workflow, ErrorMessages.WrongCode);
                setError(exports.invalidCode(attempts));
            }
            else {
                VerifyAccountTracking_1.trackOnFailure(state.workflow, ErrorMessages.UnknownError);
                setError(exports.unknownVerifyFailure);
            }
        }
    }, [verifyError]);
    return error;
};
exports["default"] = MfaError;
